require('./style.scss')
angular = require('angular')
pkg = angular
  .module 'cdms.login', []
  .config ($stateProvider) ->
    $stateProvider
      .state 'login',
        url: "/login"
        template: require('./index.pug') 
        controller: 'LoginCtrl'  
  .controller('LoginCtrl', require("./controller"))

module.exports = pkg.name


// WEBPACK FOOTER //
// ./src/component/login/index.coffee